import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrUpdatePersonFilePayload } from 'api/actions/hr-update-person-file/hr-update-person-file-payload';
import { HrUpdatePersonFilePathParameters } from 'api/actions/hr-update-person-file/hr-update-person-file-path-parameters';
import { HrUpdatePersonFileResponse } from 'api/actions/hr-update-person-file/hr-update-person-file-response';

type HrUpdatePersonFileQueryParameters = Record<string, any>;

/**
 * The path of the HrUpdatePersonFile action.
 */
export const hrUpdatePersonFileActionPath = new SweetPath<keyof HrUpdatePersonFilePathParameters>(
  '/api/hr/people/{personId}/files/{personFileId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrUpdatePersonFile actions.
 */
export default function createHrUpdatePersonFileAction(axios: AxiosInstance) {
  return function hrUpdatePersonFileAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrUpdatePersonFilePathParameters;
    query?: HrUpdatePersonFileQueryParameters;
    payload: HrUpdatePersonFilePayload;
  }) {
    const path = hrUpdatePersonFileActionPath.insert(parameters);

    return axios.request<HrUpdatePersonFileResponse, HrUpdatePersonFileResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
